<div class="expand-filter-button-container">
  <button mat-stroked-button class="expand-filter-button">
    <gb-icon icon="filter"></gb-icon>
  </button>
</div>
